export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/news-2.0e110c13-d40048.png";